/* RIVAL4x4 consent-aware acquisition evidence. No pixels or conversion events. */
(function (root, factory) {
  var api = factory(root || null);
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.R4AttributionCapture = api;
  if (root && root.document) api.init();
})(typeof window !== 'undefined' ? window : null, function (runtime) {
  'use strict';

  var STORAGE_KEY = 'r4_attribution_v1';
  var TTL_MS = 90 * 24 * 60 * 60 * 1000;
  var ALLOWED = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_term',
    'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid'
  ];
  var LIMITS = {
    utm_source: 80,
    utm_medium: 80,
    utm_campaign: 160,
    utm_id: 80,
    utm_term: 160,
    utm_content: 160,
    gclid: 256,
    gbraid: 256,
    wbraid: 256,
    fbclid: 256
  };
  var BUSINESS_TIMEZONE = 'Australia/Brisbane';
  var synced = false;

  function sanitize(value, limit) {
    if (value === null || value === undefined) return '';
    var text = String(value).trim();
    if (!text || /[\u0000-\u001F\u007F]/.test(text)) return '';
    return text.slice(0, limit || 160);
  }

  function sanitizeParameter(key, value) {
    var text = sanitize(value, LIMITS[key]);
    if (!text || /https?:\/\//i.test(text)) return '';
    if (key.indexOf('utm_') === 0 && /[^\s@]+@[^\s@]+\.[^\s@]+/.test(text)) return '';
    if (['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].indexOf(key) !== -1 && /\+?\d[\d\s().-]{7,}\d/.test(text)) return '';
    return text;
  }

  function landingPath(url) {
    try {
      var parsed = new URL(url, 'https://www.rival4x4.com.au');
      return sanitize(parsed.pathname, 240) || '/';
    } catch (_error) {
      return '/';
    }
  }

  function referrerHost(value) {
    try {
      return sanitize(new URL(value).hostname.toLowerCase(), 120);
    } catch (_error) {
      return '';
    }
  }

  function touchFromUrl(url, referrer, nowIso) {
    var parsed;
    try {
      parsed = new URL(url, 'https://www.rival4x4.com.au');
    } catch (_error) {
      return null;
    }
    var touch = {};
    var found = false;
    ALLOWED.forEach(function (key) {
      var value = sanitizeParameter(key, parsed.searchParams.get(key));
      if (value) {
        touch[key] = value;
        found = true;
      }
    });
    if (!found) return null;
    touch.landing_path = landingPath(parsed.href);
    touch.referrer_host = referrerHost(referrer);
    touch.captured_at = sanitize(nowIso || new Date().toISOString(), 40);
    touch.business_timezone = BUSINESS_TIMEZONE;
    return touch;
  }

  function parseStored(raw, nowMs) {
    try {
      var value = JSON.parse(raw || 'null');
      if (!value || value.version !== 1 || Number(value.expires_at || 0) <= nowMs) return null;
      if (!value.first_touch || !value.last_touch) return null;
      return value;
    } catch (_error) {
      return null;
    }
  }

  function mergeTouches(existing, touch, nowMs) {
    if (!touch) return existing || null;
    var first = existing && existing.first_touch ? existing.first_touch : touch;
    return {
      version: 1,
      expires_at: nowMs + TTL_MS,
      journey_id: existing && existing.journey_id ? existing.journey_id : undefined,
      first_touch: first,
      last_touch: touch
    };
  }

  function journeyId(env, nowMs) {
    try {
      if (env.crypto && typeof env.crypto.randomUUID === 'function') {
        return 'r4_' + env.crypto.randomUUID().replace(/-/g, '');
      }
      if (env.crypto && typeof env.crypto.getRandomValues === 'function') {
        var values = new Uint32Array(2);
        env.crypto.getRandomValues(values);
        return 'r4_' + nowMs.toString(36) + '_' + values[0].toString(36) + values[1].toString(36);
      }
    } catch (_error) {}
    return 'r4_' + nowMs.toString(36) + '_' + Math.random().toString(36).slice(2, 14);
  }

  function storageRead(env, nowMs) {
    try {
      return parseStored(env.localStorage.getItem(STORAGE_KEY), nowMs);
    } catch (_error) {
      return null;
    }
  }

  function storageWrite(env, value) {
    try {
      env.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
      return true;
    } catch (_error) {
      return false;
    }
  }

  function marketingAllowed(env) {
    try {
      var privacy = env.Shopify && env.Shopify.customerPrivacy;
      return Boolean(privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed());
    } catch (_error) {
      return false;
    }
  }

  function capture(env, now) {
    if (!env || !marketingAllowed(env)) return null;
    var nowMs = now instanceof Date ? now.getTime() : Date.now();
    var nowIso = now instanceof Date ? now.toISOString() : new Date(nowMs).toISOString();
    var existing = storageRead(env, nowMs);
    var current = touchFromUrl(env.location && env.location.href, env.document && env.document.referrer, nowIso);
    var merged = mergeTouches(existing, current, nowMs);
    if (merged && !merged.journey_id) merged.journey_id = journeyId(env, nowMs);
    if (merged && (current || !existing)) storageWrite(env, merged);
    return merged;
  }

  function privateAttributes(value) {
    if (!value || !value.first_touch || !value.last_touch) return {};
    var first = value.first_touch;
    var last = value.last_touch;
    var attrs = {
      __r4_first_source: first.utm_source,
      __r4_first_medium: first.utm_medium,
      __r4_first_campaign: first.utm_campaign,
      __r4_first_campaign_id: first.utm_id,
      __r4_first_landing: first.landing_path,
      __r4_first_at: first.captured_at,
      __r4_last_source: last.utm_source,
      __r4_last_medium: last.utm_medium,
      __r4_last_campaign: last.utm_campaign,
      __r4_last_campaign_id: last.utm_id,
      __r4_last_content: last.utm_content,
      __r4_last_term: last.utm_term,
      __r4_last_landing: last.landing_path,
      __r4_last_at: last.captured_at,
      __r4_business_tz: BUSINESS_TIMEZONE,
      __r4_journey_id: value.journey_id,
      __r4_referrer_host: last.referrer_host,
      __r4_gclid: last.gclid || first.gclid,
      __r4_gbraid: last.gbraid || first.gbraid,
      __r4_wbraid: last.wbraid || first.wbraid,
      __r4_fbclid: last.fbclid || first.fbclid
    };
    Object.keys(attrs).forEach(function (key) {
      attrs[key] = sanitize(attrs[key], 256);
      if (!attrs[key]) delete attrs[key];
    });
    return attrs;
  }

  function cartEndpoint(env) {
    var rootPath = (env.Shopify && env.Shopify.routes && env.Shopify.routes.root) || '/';
    return String(rootPath).replace(/\/?$/, '/') + 'cart/update.js';
  }

  function syncCart(env, value) {
    var attrs = privateAttributes(value);
    if (!env || typeof env.fetch !== 'function' || !Object.keys(attrs).length) return Promise.resolve(false);
    return env.fetch(cartEndpoint(env), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (response) {
      return Boolean(response && response.ok);
    }).catch(function () {
      return false;
    });
  }

  function run(env) {
    env = env || runtime;
    if (!env || !marketingAllowed(env)) return Promise.resolve(false);
    var value = capture(env);
    if (!value) return Promise.resolve(false);
    return syncCart(env, value).then(function (ok) {
      synced = synced || ok;
      return ok;
    });
  }

  function isCartAddForm(form) {
    var action = String((form && form.action) || '');
    return action.indexOf('/cart/add') !== -1;
  }

  function init(env) {
    env = env || runtime;
    if (!env || !env.document) return;
    run(env);
    env.document.addEventListener('shopifyCustomerPrivacyApiLoaded', function () { run(env); });
    env.document.addEventListener('visitorConsentCollected', function () { run(env); });
    env.document.addEventListener('submit', function (event) {
      if (!synced && isCartAddForm(event.target)) setTimeout(function () { run(env); }, 0);
    }, true);
    ['cart:updated', 'cart:refresh', 'variant:added'].forEach(function (name) {
      env.document.addEventListener(name, function () { if (!synced) run(env); });
    });
  }

  return {
    STORAGE_KEY: STORAGE_KEY,
    TTL_MS: TTL_MS,
    ALLOWED: ALLOWED.slice(),
    sanitize: sanitize,
    sanitizeParameter: sanitizeParameter,
    touchFromUrl: touchFromUrl,
    parseStored: parseStored,
    mergeTouches: mergeTouches,
    marketingAllowed: marketingAllowed,
    capture: capture,
    privateAttributes: privateAttributes,
    cartEndpoint: cartEndpoint,
    syncCart: syncCart,
    init: init
  };
});
